if (document.body.classList.contains("News")) {
	const showArticlesButton = document.getElementById("show-articles");

	showArticlesButton?.addEventListener("click", () => {
		const articles = document.getElementById("articles");
		const range = parseInt(articles.dataset.range);
		const newRange = range + 3;
		let articleCount = 0;

		articles.querySelectorAll(".article").forEach((element, index) => {
			element.classList.toggle("show", index < newRange);
			articleCount++;
		});

		articles.dataset.range = newRange.toString();

		showArticlesButton.classList.toggle("hide", articleCount <= newRange);
	});

	// for (let event of document.querySelectorAll("#events .event-item .event-title")) {
	// 	event.addEventListener("mouseenter", () => {
	// 		const index = event.dataset.index;

	// 		document.querySelectorAll("#events .event-image.visible")
	// 		.forEach(img => img.classList.remove("visible"));
			
	// 		document.querySelectorAll(`#events .event-image[data-index="${index}"]`)
	// 		.forEach(img => img.classList.add("visible"));
	// 	});
	// }

	const loadMoreArticlesButton = document.getElementById("btn-load-news");

	loadMoreArticlesButton?.addEventListener("click", () => {
        const articles = document.getElementById("headlines");
        const page = parseInt(articles.dataset.page);
        const newPage = page + 1;
        let articleCount = 0;
        fetch(`/ajax/news?page=${newPage}`).then(response => response.json()).then(data => {
            if (data.content === "") {
                loadMoreArticlesButton.style.display = "none";
                return;
            }
            articles.innerHTML += data.content;
            articles.dataset.page = newPage.toString();
            showArticlesButton.classList.toggle("hide", data.page <= newPage);
        });
    });

}